import { createGaActionCreator } from '@zocdoc-frontend-common/utils-react/createGaActionCreator';
import { SIGN_IN_GA_CATEGORY, GaActionText } from '../../constants';

export const TRACK_FACEBOOK_LOGIN = '@@signinform/TRACK_FACEBOOK_LOGIN';
export const TRACK_GOOGLE_LOGIN = '@@signinform/TRACK_GOOGLE_LOGIN';
export const TRACK_APPLE_LOGIN = '@@signinform/TRACK_APPLE_LOGIN';
export const TRACK_CLICK_CREATE_ACCOUNT =
    '@@signinform/TRACK_CLICK_CREATE_ACCOUNT';

export const trackClickFacebookLogin = () =>
    createGaActionCreator(
        TRACK_FACEBOOK_LOGIN,
        SIGN_IN_GA_CATEGORY,
        GaActionText.trackClickFacebookLogin
    );

export const trackClickGoogleLogin = () =>
    createGaActionCreator(
        TRACK_GOOGLE_LOGIN,
        SIGN_IN_GA_CATEGORY,
        GaActionText.trackClickGoogleLogin
    );

export const trackClickAppleLogin = () =>
    createGaActionCreator(
        TRACK_APPLE_LOGIN,
        SIGN_IN_GA_CATEGORY,
        GaActionText.trackClickAppleLogin
    );

export const trackClickCreateAccount = () =>
    createGaActionCreator(
        TRACK_CLICK_CREATE_ACCOUNT,
        SIGN_IN_GA_CATEGORY,
        GaActionText.trackClickCreateAccount
    );
